/* eslint-disable react/require-default-props,react/forbid-prop-types,react/destructuring-assignment */

import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import './BootstrapModal.scss';

/**
 * A React component that uses Bootstrap styling to display a modal dialog.
 *
 * Potential code duplication: ReactModalDialog/ModalDialog/Dialog/BootstrapModal
 */
export class BootstrapModal extends React.Component {
  static displayName = 'BootstrapModal';

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func, // triggered as user clicks close/cancel buttons
    onClosed: PropTypes.func, // triggered after modal has faded out
    dialogClassName: PropTypes.string,
    backdrop: PropTypes.oneOf(['static', true, false]),
    children: PropTypes.any.isRequired,
  };

  static getExtraProps(props) {
    const { onHide, onClosed, dialogClassName, backdrop } = props;
    const extraProps = {};
    if (onHide) {
      extraProps.onHide = onHide;
    }
    if (dialogClassName) {
      extraProps.dialogClassName = dialogClassName;
    }
    extraProps.bsClass = 'react-modal';

    if (backdrop) {
      extraProps.backdrop = backdrop;
    }

    if (onClosed) {
      extraProps.onExited = onClosed;
    }

    return extraProps;
  }

  render() {
    const { show } = this.props;
    const extraProps = BootstrapModal.getExtraProps(this.props);

    return (
      <Modal {...{ show }} {...extraProps}>
        {this.props.children}
      </Modal>
    );
  }
}
